import { render, staticRenderFns } from "./DepartmentInvoiceTable.vue?vue&type=template&id=0131e9ef"
import script from "./DepartmentInvoiceTable.vue?vue&type=script&lang=js"
export * from "./DepartmentInvoiceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports